import { ComponentProps } from 'react'

import { Text } from '@joor/design-system'
import styled from 'styled-components'

type TextProps = ComponentProps<typeof Text>
export const commonTextProps: Pick<
  TextProps,
  'fontSize' | 'letterSpacing' | 'lineHeight'
> = {
  fontSize: 'small',
  letterSpacing: 'tighter',
  lineHeight: '20',
}

export const DefaultContainer = styled.div`
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
`

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 480px;
`
